/* <pdp-gallery>: scroll-snap slider with arrows, thumbnails, active state, video play/pause. No dependencies. */
if (!customElements.get('pdp-gallery')) {
  class PdpGallery extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      const sig = { signal: this.ac.signal };
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.index = 0;
      if (!this.track || this.slides.length === 0) return;
      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true, signal: this.ac.signal });
      if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1), sig);
      if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1), sig);
      this.thumbs.forEach((t) => {
        t.addEventListener('click', () => this.go(parseInt(t.dataset.index, 10)), sig);
        t.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); const n = this.index + (e.key === 'ArrowRight' ? 1 : -1); this.go(n); (this.thumbs[this.clamp(n)] || t).focus(); }
        }, sig);
      });
      this.querySelectorAll('[data-play]').forEach((btn) => btn.addEventListener('click', () => this.togglePlay(btn), sig));
      this.sync();
    }
    disconnectedCallback() { if (this.ac) this.ac.abort(); }
    clamp(n) { return Math.max(0, Math.min(this.slides.length - 1, n)); }
    go(n) {
      n = this.clamp(n);
      const slide = this.slides[n];
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      this.index = n; this.sync();
    }
    onScroll() {
      clearTimeout(this.t);
      this.t = setTimeout(() => {
        const x = this.track.scrollLeft; let best = 0, dist = Infinity;
        this.slides.forEach((s, i) => { const d = Math.abs((s.offsetLeft - this.track.offsetLeft) - x); if (d < dist) { dist = d; best = i; } });
        if (best !== this.index) { this.index = best; this.sync(); }
      }, 60);
    }
    sync() {
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.index));
      this.thumbs.forEach((t, i) => { const on = i === this.index; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; if (on && typeof t.scrollIntoView === 'function') t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      this.slides.forEach((s, i) => {
        const v = s.querySelector('video'); if (!v) return;
        if (i === this.index && this.dataset.autoplay === 'true') { v.play().catch(() => {}); } else { v.pause(); }
        const btn = s.querySelector('[data-play]'); if (btn) btn.classList.toggle('is-playing', !v.paused);
      });
    }
    togglePlay(btn) {
      const v = btn.parentElement.querySelector('video'); if (!v) return;
      if (v.paused) { v.play().catch(() => {}); btn.classList.add('is-playing'); btn.setAttribute('aria-label', 'Pause video'); }
      else { v.pause(); btn.classList.remove('is-playing'); btn.setAttribute('aria-label', 'Play video'); }
    }
  }
  customElements.define('pdp-gallery', PdpGallery);
}
